import * as React from 'react';
export const OutputIcon = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    xmlSpace='preserve'
    style={{
      enableBackground: 'new 0 0 24 24',
    }}
    viewBox='0 0 24 24'
    {...props}
  >
    <path d='M0 0h24v24H0V0z' fill='none' />
    <path d='M19 13v5c0 .5-.5 1-1 1H6c-.6 0-1-.5-1-1v-5c0-.6-.4-1-1-1s-1 .4-1 1v6c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-6c0-.6-.5-1-1-1s-1 .4-1 1zm-6-.3 1.9-1.9c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4l-3.6 3.6c-.4.4-1 .4-1.4 0l-3.6-3.6c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0l1.9 1.9V4c0-.5.4-1 1-1s1 .5 1 1v8.7z' />
  </svg>
);



// WEBPACK FOOTER //
// ./src/components/icons/OutputIcon.jsx